import React, { FC } from 'react';
import { Card, Descriptions, Typography, Tag, Space, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { SurveySubmission } from '../../core/survey/types';

const { Title, Text } = Typography;

interface SurveyAnswerDetailProps {
    submission: SurveySubmission;
    onBack: () => void;
}

const SurveyAnswerDetail: FC<SurveyAnswerDetailProps> = ({ submission, onBack }) => {
    const formatDate = (dateString: string) => new Date(dateString).toLocaleString('lt-LT');

    const getQuestionTypeLabel = (type: string) => {
        switch (type) {
        case 'text':
            return 'Tekstinis atsakymas';
        case 'single':
            return 'Vienas pasirinkimas';
        case 'multiple':
            return 'Keli pasirinkimai';
        case 'paragraph':
            return 'Paragrafas';
        default:
            return type;
        }
    };

    const renderAnswer = (answer: any) => {
        switch (answer.question_type) {
        case 'text':
            return <Text>{answer.answers[0] || 'Nėra atsakymo'}</Text>;
        case 'single':
            return <Tag color="blue">{answer.answers[0] || 'Nėra atsakymo'}</Tag>;
        case 'multiple':
            return (
                <Space direction="vertical">
                    {answer.answers.map((ans: string, index: number) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Tag key={index} color="green">{ans}</Tag>
                    ))}
                </Space>
            );
        default:
            return <Text>{answer.answers.join(', ') || 'Nėra atsakymo'}</Text>;
        }
    };

    return (
        <div className="survey-answer-detail">
            <Card>
                <div style={{ marginBottom: 16 }}>
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined />}
                        onClick={onBack}
                        style={{ marginBottom: 16 }}>
                        Grįžti atgal
                    </Button>
                    <Title level={4}>Atsakymo detalės</Title>
                </div>

                <Descriptions title="Bendra informacija" bordered column={2}>
                    <Descriptions.Item label="Atsakymo ID">{submission.id}</Descriptions.Item>
                    <Descriptions.Item label="Pateikimo data">{formatDate(submission.submitted_at)}</Descriptions.Item>
                    <Descriptions.Item label="IP adresas">{submission.ip_address}</Descriptions.Item>
                    <Descriptions.Item label="Unikalus hash">{submission.unique_hash}</Descriptions.Item>
                    <Descriptions.Item label="Naršyklė" span={2}>
                        <Text style={{ fontSize: '12px' }}>{submission.user_agent}</Text>
                    </Descriptions.Item>
                </Descriptions>

                <div style={{ marginTop: 24 }}>
                    <Title level={5}>Atsakymai į klausimus</Title>
                    {submission.answers.map((answer, index) => (
                        <Card
                            key={answer.question_id}
                            size="small"
                            style={{ marginBottom: 16 }}
                            title={`${index + 1}. ${answer.question_title}`}>
                            <div style={{ marginBottom: 8 }}>
                                <Text type="secondary">Klausimo tipas: </Text>
                                <Tag color="purple">{getQuestionTypeLabel(answer.question_type)}</Tag>
                            </div>
                            <div>
                                <Text strong>Atsakymas:</Text>
                                <div style={{ marginTop: 8 }}>
                                    {renderAnswer(answer)}
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            </Card>
        </div>
    );
};

export default SurveyAnswerDetail;
